import { useRouter } from 'next/router'
import React from 'react'
import { usePostLoginRoute } from '../../config/router'
import { useAuthentication } from '../../state'

export const withPublic = (Component) => (props) => {
  const { authenticated, verificationRequired } = useAuthentication()
  const router = useRouter()
  const postLoginRoute = usePostLoginRoute()

  if (typeof window !== 'undefined') {
    router.beforePopState(({ url, options }) => {
      if (authenticated && !verificationRequired) {
        router.push(postLoginRoute)
      }
      return !authenticated
    })
  }
  return <Component {...props} />
}
